import { prefix } from "../../../design-tokens/meta";
export const componentName = "TableCell";

export const componentClasses = {
    basic: `${prefix}td`,
    cell: `${prefix}table__cell`,
    align: {
        end: `${prefix}td--align-end`,
    },
};

export const views = Object.freeze({
    rest: {
        classList: [componentClasses.basic],
        attrs: { role: "cell" },
    },
    align: {
        end: {
            classList: [componentClasses.basic, componentClasses.align.end],
        },
    },
});
